<!-- <p>user-create-poll works!</p> -->

<div class="poll-container">
  <mat-grid-list cols="2" rowHeight="100px" gutterSize="10px">
    <mat-grid-tile
      [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
      [rowspan]="screenInfo == ScreenType.Mobile ? 6 : 7"
    >
      <div class="create-poll-form-container">
        <div class="create-poll-form-header">
          <h4>Create Poll</h4>
        </div>
        <div class="create-poll-form-fields">
          <form [formGroup]="pollForm">
            <mat-grid-list cols="2" rowHeight="80px">
              <mat-grid-tile colspan="2">
                <div class="mat-form-field-div">
                  <mat-form-field
                    class="question-subject-form-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      placeholder="Enter the question/subject for the poll"
                      formControlName="question"
                    />
                  </mat-form-field>
                </div>
              </mat-grid-tile>

              <div formArrayName="options">
                <mat-grid-tile
                  [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
                  *ngFor="let option of options.controls; let i = index"
                >
                  <div class="mat-form-field-option-div">
                    <mat-form-field
                      appearance="outline"
                      class="Option-form-field"
                      subscriptSizing="dynamic"
                    >
                      <input
                        matInput
                        [formControlName]="i"
                        placeholder="Option {{ i + 1 }}"
                      />
                    </mat-form-field>
                    <button
                      *ngIf="i === this.getMaxIndex() && i > 0"
                      type="button"
                      mat-icon-button
                      (click)="removeOption(i)"
                    >
                      <mat-icon>remove_circle </mat-icon>
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="toggleOption(i)"
                    >
                      <mat-icon>{{
                        i === this.getMaxIndex()
                          ? "add_circle"
                          : "remove_circle"
                      }}</mat-icon>
                    </button>
                  </div>
                </mat-grid-tile>
              </div>

              <mat-grid-tile
                [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              >
                <div class="mat-form-field-div">
                  <mat-form-field
                    class="question-subject-form-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                    ><mat-label>Date of poll to make live</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      [matDatepicker]="startDatePicker"
                      placeholder="Date of poll to make live"
                      formControlName="startDate"
                      [min]="minDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="startDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              >
                <div class="mat-form-field-div">
                  <mat-form-field
                    class="question-subject-form-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Time of poll to make live</mat-label>
                    <input
                      matInput
                      [ngxTimepicker]="startTimePicker"
                      formControlName="startTime"
                      [min]="minTime"
                    />
                    <ngx-material-timepicker
                      #startTimePicker
                    ></ngx-material-timepicker>
                  </mat-form-field>
                </div>
              </mat-grid-tile>

              <mat-grid-tile
                [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              >
                <div class="mat-form-field-div">
                  <mat-form-field
                    class="question-subject-form-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>End date of poll</mat-label>
                    <input
                      matInput
                      [matDatepicker]="endDatePicker"
                      formControlName="endDate"
                      [min]="minDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="endDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
              >
                <div class="mat-form-field-div">
                  <mat-form-field
                    class="question-subject-form-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                    ><mat-label>End time of poll</mat-label>
                    <input
                      matInput
                      [ngxTimepicker]="endTimePicker"
                      placeholder="End time of poll"
                      formControlName="endTime"
                    />
                    <ngx-material-timepicker
                      #endTimePicker
                    ></ngx-material-timepicker>
                  </mat-form-field>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                colspan="2"
                *ngIf="pollForm.hasError('endDateInvalid')"
              >
                <div class="error-banner">
                  End date must be after start date
                </div>
              </mat-grid-tile>
              <mat-grid-tile colspan="2">
                <div
                  [ngClass]="{
                    'send-results-field-div':
                      screenInfo == ScreenType.Desktop ||
                      screenInfo == ScreenType.Tablet,
                    'send-results-field-div-mobile':
                      screenInfo == ScreenType.Mobile
                  }"
                >
                  <h6>Send Results:</h6>
                  <mat-radio-group
                    formControlName="sendResultsTo"
                    (change)="sendResultsToChanged($event.value)"
                  >
                    <mat-radio-button value="everyone"
                      >Everyone</mat-radio-button
                    >
                    <mat-radio-button value="me">Me</mat-radio-button>
                    <mat-radio-button value="select">Select</mat-radio-button>
                  </mat-radio-group>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]="screenInfo == ScreenType.Mobile ? 2 : 2"
                rowspan="1"
                *ngIf="pollForm.get('sendResultsTo').value === 'select'"
              >
                <!-- <div class="checkbox-user-list">
                  <div *ngFor="let user of users; let i = index">
                    <mat-checkbox
                      [checked]="user.selected"
                      (change)="onChange($event, user)"
                      >{{ user.firstname + " " + user.lastname }}</mat-checkbox
                    >
                  </div>
                </div> -->
                <div class="mat-form-field-div">
                  <mat-form-field
                    appearance="outline"
                    class="question-subject-form-field"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Select Users</mat-label>
                    <input
                      matInput
                      [formControl]="selectedUsersControl"
                      [matAutocomplete]="auto"
                    />
                    <mat-icon
                      style="background-color: transparent; color: #e93578"
                      matSuffix
                      (click)="clearInputField()"
                      >clear</mat-icon
                    >
                    <mat-autocomplete
                      (optionSelected)="addUser($event)"
                      #auto="matAutocomplete"
                    >
                      <mat-option
                        *ngFor="let host of filteredHosts"
                        [value]="host.firstname + ' ' + host.lastname"
                      >
                        {{ host.firstname + " " + host.lastname }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                *ngIf="pollForm.get('sendResultsTo').value === 'select'"
                colspan="2"
              >
                <div class="selected-users">
                  <mat-chip
                    *ngFor="let user of usersTemp"
                    [removable]="true"
                    (removed)="removeUser(user)"
                  >
                    {{ user }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </div>
              </mat-grid-tile>
              <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
                ><div class="mat-form-field-div">
                  <button
                    type="submit"
                    mat-raised-button
                    [disabled]="isSaveDiabled()"
                    (click)="captureDivAsImage()"
                  >
                    Save
                  </button>
                </div></mat-grid-tile
              >
            </mat-grid-list>
          </form>
        </div>
      </div>
    </mat-grid-tile>
    <mat-grid-tile rowspan="7" *ngIf="false">
      <form [formGroup]="pollForm">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Enter the question/subject for the poll"
            formControlName="question"
          />
        </mat-form-field>

        <h3>Options</h3>
        <div formArrayName="options">
          <div *ngFor="let option of options.controls; let i = index">
            <mat-form-field appearance="outline">
              <input
                matInput
                [formControlName]="i"
                placeholder="Option {{ i + 1 }}"
              />
            </mat-form-field>
            <button mat-icon-button color="warn" (click)="removeOption(i)">
              <mat-icon>remove_circle</mat-icon>
            </button>
          </div>
        </div>
        <!-- <button mat-button (click)="addOption()">Add Option</button> -->

        <h3>Date and Time</h3>
        <mat-form-field appearance="outline">
          <input
            matInput
            [matDatepicker]="startDatePicker"
            placeholder="Date of poll to make live"
            formControlName="startDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <input
            matInput
            [ngxTimepicker]="startTimePicker"
            placeholder="Time of poll to make live"
            formControlName="startTime"
          />
          <ngx-material-timepicker #startTimePicker></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <input
            matInput
            [matDatepicker]="endDatePicker"
            placeholder="End date of poll"
            formControlName="endDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <input
            matInput
            [ngxTimepicker]="endTimePicker"
            placeholder="End time of poll"
            formControlName="endTime"
          />
          <ngx-material-timepicker #endTimePicker></ngx-material-timepicker>
        </mat-form-field>

        <h3>Send Results To {{ pollForm.get("sendResultsTo").value }}</h3>
        <mat-radio-group
          formControlName="sendResultsTo"
          (change)="sendResultsToChanged($event.value)"
        >
          <mat-radio-button value="everyone">Everyone</mat-radio-button>
          <mat-radio-button value="me">Me</mat-radio-button>
          <mat-radio-button value="select">Select</mat-radio-button>
        </mat-radio-group>

        <!-- <div *ngIf="pollForm.get('sendResultsTo').value === 'select'">
          <div *ngFor="let user of users; let i = index">
            <mat-checkbox
              [checked]="user.selected"
              (change)="user.selected = $event.checked"
              >{{ user.name }}</mat-checkbox
            >
          </div>
        </div> -->
      </form>
    </mat-grid-tile>
    <mat-grid-tile
      rowspan="7"
      [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
    >
      <!-- Add this section to display the preview -->
      <div class="poll-preview-section">
        <div class="create-poll-form-header">
          <h4>Poll Preview</h4>
        </div>
        <div class="poll-card">
          <div
            [ngClass]="{
              'poll-header':
                screenInfo == ScreenType.Desktop ||
                screenInfo == ScreenType.Tablet,
              'poll-header-mobile': screenInfo == ScreenType.Mobile
            }"
          >
            <h5 class="poll-question">
              {{ pollForm.get("question").value || "Sample Question/Subject" }}
            </h5>
          </div>
          <ul class="poll-options">
            <li
              *ngFor="let option of options.controls; let i = index"
              class="poll-option"
            >
              <div class="option-index">
                {{ i + 1 }}
              </div>
              <div class="option-text">
                {{ option.value || "Option" }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>

  <!-- <form [formGroup]="pollForm">

    <mat-form-field>
      <input
        matInput
        placeholder="Enter the question/subject for the poll"
        formControlName="question"
      />
    </mat-form-field>

    <h3>Options</h3>
    <div formArrayName="options">
      <div *ngFor="let option of options.controls; let i = index">
        <mat-form-field>
          <input
            matInput
            [formControlName]="i"
            placeholder="Option {{ i + 1 }}"
          />
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removeOption(i)">
          <mat-icon>remove_circle</mat-icon>
        </button>
      </div>
    </div>
    <button mat-button (click)="addOption()">Add Option</button>

    <h3>Date and Time</h3>
    <mat-form-field>
      <input
        matInput
        [matDatepicker]="startDatePicker"
        placeholder="Date of poll to make live"
        formControlName="startDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        [ngxTimepicker]="startTimePicker"
        placeholder="Time of poll to make live"
        formControlName="startTime"
      />
      <ngx-material-timepicker #startTimePicker></ngx-material-timepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        [matDatepicker]="endDatePicker"
        placeholder="End date of poll"
        formControlName="endDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        [ngxTimepicker]="endTimePicker"
        placeholder="End time of poll"
        formControlName="endTime"
      />
      <ngx-material-timepicker #endTimePicker></ngx-material-timepicker>
    </mat-form-field>

    <h3>Send Results To {{ pollForm.get("sendResultsTo").value }}</h3>
    <mat-radio-group
      formControlName="sendResultsTo"
      (change)="sendResultsToChanged($event.value)"
    >
      <mat-radio-button value="everyone">Everyone</mat-radio-button>
      <mat-radio-button value="me">Me</mat-radio-button>
      <mat-radio-button value="select">Select</mat-radio-button>
    </mat-radio-group>
  </form>
  <div *ngIf="pollForm.get('sendResultsTo').value === 'select'">
    <div *ngFor="let user of users; let i = index">
      <mat-checkbox
        [checked]="user.selected"
        (change)="user.selected = $event.checked"
        >{{ user.name }}</mat-checkbox
      >
    </div>
  </div> -->

  <div class="button-container"></div>
</div>
